<template>
  <iBottomSheet
    v-if="asSheet"
    :model-value="true"
    :height-percentage="SHEET_HEIGHT_PERCENTAGE"
    @update:model-value="close"
    @close="close"
  >
    <iColumn
      gap="standard"
      width="fill"
      wrap="nowrap"
      :style-overrides="SHEET_PADDING"
      data-test="save-chooser"
      data-presentation="sheet"
    >
      <iText font-weight="dark" font-size="large">
        Saved
      </iText>
      <SaveToCollectionChooserBody />
    </iColumn>
  </iBottomSheet>
  <iModal
    v-else
    title="Saved"
    :show-footer="false"
    :max-width="MODAL_MAX_WIDTH"
    :close-on-backdrop="backdropSettled"
    data-test="save-chooser"
    data-presentation="modal"
    @close="close"
  >
    <template #header>
      <iRow
        width="fill"
        align="between"
        vertical-align="middle"
        wrap="nowrap"
      >
        <iText font-weight="dark" font-size="large">
          Saved
        </iText>
        <iIcon
          icon="close"
          name="close"
          aria-label="Close"
          data-test="save-chooser-close"
          @click="close"
        />
      </iRow>
    </template>
    <template #body>
      <SaveToCollectionChooserBody />
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useWindowStore } from "@vcl";
import { useSavedPostsStore } from "%/dynamic-component-editor/stores/saved-posts-store";
import { CHOOSER_AS_SHEET, chooserPresentation } from "%/dynamic-component-editor/helpers/saved-posts.mjs";
import SaveToCollectionChooserBody from "%/dynamic-component-editor/components/saved-posts/SaveToCollectionChooserBody.vue";
import { BackdropSettleMixin } from "%/dynamic-component-editor/mixins/backdrop-settle-mixin";

const MODAL_MAX_WIDTH = 420;
const SHEET_HEIGHT_PERCENTAGE = 40;
const SHEET_PADDING = Object.freeze({ paddingLeft: "standard", paddingRight: "standard", paddingBottom: "large" });

export default {
  name: "SaveToCollectionChooser",
  components: { SaveToCollectionChooserBody },
  mixins: [BackdropSettleMixin],
  data() {
    return { MODAL_MAX_WIDTH, SHEET_HEIGHT_PERCENTAGE, SHEET_PADDING };
  },
  computed: {
    ...mapState(useWindowStore, ["$vssMobile"]),
    asSheet() {
      return chooserPresentation({ phoneWidth: this.$vssMobile }) === CHOOSER_AS_SHEET;
    },
  },
  mounted() {
    useWindowStore().init();
    this.settleBackdrop();
  },
  beforeUnmount() {
    useWindowStore().remove();
  },
  methods: {
    ...mapActions(useSavedPostsStore, { close: "closeChooser" }),
  },
};
</script>
